import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import React, { useEffect, useMemo } from "react";
import { formValueSelector } from "redux-form/immutable";

import { toggleModal } from "altus-modal";

import {
  ACTIONS,
  SORT_DIRECTION,
  MOBILE_FACILITY_FORM,
} from "features/planner/planner.constants";

import {
  editMobileFacilityOnSubmit,
  initializeEditMobileFacility,
  createMobileFacilityOnSubmit,
  getStationaryAndMobileFacilities,
  deleteMobileFacility,
} from "features/planner/planner.actions";

import {
  getSummarizedDataStatesFromState,
  getCurrentUserAppRolesFromState,
} from "app/app.selectors";

import CrudBasePage from "app/components/CrudBasePage";
import MuiOilrigIcon from "app/components/MuiOilrigIcon";
import { getAccessControlButton } from "utils/component.util";
import { getModifiedByValue, hasRequiredAccessLevel } from "utils/app.util";
import { getMobileFacilitiesFromState } from "features/planner/planner.selectors";
import MobileFacilityForm from "features/planner/settings/mobileFacilities/components/MobileFacilityForm";

const editMobileFacilitySelector = formValueSelector(MOBILE_FACILITY_FORM.ID);

const SettingsMobileFacilitiesContainer = ({
  dataState,
  sourceUri,
  breadcrumb,
  facilities,
  crudAccessLevel,
  currentUserAppRoles,
  dispatchGetMobileFacilities,
  dispatchDeleteMobileFacility,
  dispatchEditMobileFacilityOnSubmit,
  dispatchInitializeEditMobileFacility,
  dispatchCreateMobileFacilityOnSubmit,
}) => {
  useEffect(() => {
    dispatchGetMobileFacilities();
  }, [dispatchGetMobileFacilities]);

  const columns = useMemo(
    () => [
      {
        xs: true,
        title: "Name",
        getSortProperty: item => item.get("name"),
      },
      {
        xs: true,
        title: "Operator",
        getSortProperty: item => item.get("operator"),
      },
      {
        xs: true,
        title: "Nation",
        getSortProperty: item => item.get("nation"),
      },
      {
        xs: true,
        component: Grid,
        title: "Modified by",
        getSortProperty: item => item.get("modifiedBy"),
        getValue: getModifiedByValue,
      },
    ],
    [],
  );

  const actions = useMemo(
    () => [
      getAccessControlButton(
        crudAccessLevel.delete,
        dispatchDeleteMobileFacility,
        <Delete fontSize="small" />,
        "Delete",
      ),
    ],
    [crudAccessLevel, dispatchDeleteMobileFacility],
  );

  return (
    <CrudBasePage
      Icon={MuiOilrigIcon}
      title={breadcrumb}
      items={facilities}
      displayAddButton={hasRequiredAccessLevel(
        crudAccessLevel.create,
        currentUserAppRoles,
      )}
      displaySearchField
      dataState={dataState}
      EditEntityFormComponent={MobileFacilityForm}
      CreateEntityFormComponent={MobileFacilityForm}
      SortableListProps={{
        defaultSortColumn: 0,
        actions: actions,
        columns: columns,
        getKey: mobileFacility => mobileFacility.get("id"),
        defaultSortDirection: SORT_DIRECTION.ASC,
        onRowClick: hasRequiredAccessLevel(
          crudAccessLevel.edit,
          currentUserAppRoles,
        )
          ? dispatchInitializeEditMobileFacility
          : null,
      }}
      EditModalProps={{
        submitText: "Save",
        title: "Edit facility",
        onSubmit: dispatchEditMobileFacilityOnSubmit,
        formTitleField: MOBILE_FACILITY_FORM.NAME,
        displaySubmitBtn: sourceUri ? false : true,
      }}
      EditEntityFormProps={{
        sourceUri,
      }}
      CreateModalProps={{
        submitText: "Create",
        title: "Create facility",
        onSubmit: dispatchCreateMobileFacilityOnSubmit,
      }}
      editEntityForm={{
        form: MOBILE_FACILITY_FORM.ID,
      }}
      createEntityForm={{
        form: MOBILE_FACILITY_FORM.ID,
      }}
    />
  );
};

export default compose(
  connect(
    state => ({
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
      facilities: getMobileFacilitiesFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_MOBILE_FACILITIES,
        ACTIONS.DELETE_MOBILE_FACILITY,
      ),
      sourceUri: editMobileFacilitySelector(
        state,
        MOBILE_FACILITY_FORM.SOURCE_URI,
      ),
    }),
    {
      dispatchToggleModal: toggleModal,
      dispatchGetMobileFacilities: getStationaryAndMobileFacilities,
      dispatchEditMobileFacilityOnSubmit: editMobileFacilityOnSubmit,
      dispatchDeleteMobileFacility: deleteMobileFacility,
      dispatchInitializeEditMobileFacility: initializeEditMobileFacility,
      dispatchCreateMobileFacilityOnSubmit: createMobileFacilityOnSubmit,
    },
  ),
)(SettingsMobileFacilitiesContainer);
